import React from 'react';
import './faqs.scss';

const SeoFaqs = ({ city, state, faqs, faqTitle, subObj }) => {
    const name = city?.name || state?.name;
    const title = faqTitle || `Frequently asked questions about ${name} ${subObj?.seoTitle.toLowerCase() || 'dog park'}`;

    return (
        <div className="sniff-faq">
            <div className="l-container">
                <h2 className="snif-m2 snif-l2-pc snif-semibold mt-md-3 mb-3">{title}</h2>
                <div className="faqs-table" itemScope itemType="https://schema.org/FAQPage">
                    {faqs.map((F, i) => (
                        <div key={i} itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
                            <div className="snif-p snif-semibold mb-1" itemProp="name">
                                {F.que}
                            </div>
                            <div className="snif-p snif-regular" itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                                <div itemProp="text">
                                    <F.ans />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SeoFaqs;
